import { FloraTypography } from '@grupoboticario/flora-react'

import * as S from './NumberTextWithColor.styles'

const NumberTextWithColor = ({ value, children }) => (
  <FloraTypography css={S.getValueColorCss(value)} fontSize="bodySmallStandard">
    {children}
  </FloraTypography>
)

export default NumberTextWithColor
